import { action } from 'satcheljs/lib/legacy';
export default action('addMentionAddedRecipient')(function addMentionAddedRecipient(viewState, recipient) {
    viewState.mentionsAddedRecipients.push(recipient.EmailAddress.EmailAddress);
});
//# sourceMappingURL=addMentionAddedRecipient.js.map